import * as Sentry from "@sentry/react";
import Helper from "../../Helper";

export function archiveProjectMessage(teamSubdomain: string, token: string, message_id: number): Promise<any> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${token}/messages/${message_id}`;
    const options = {
        method: "DELETE",
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                return Sentry.captureException(new Error("Unable to archive project message"));
            }
        })
        .catch(() => {
            return Sentry.captureException(new Error("Unable to archive project message"));
        });
}
